var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThankingVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 175,
    viewBox: "0 0 322 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.546 14.5454L193.648 28.48L217.295 28.4363L224.557 50.9381L243.713 64.8L236.364 87.2727L243.713 109.745L224.557 123.607L217.295 146.109L193.648 146.065L174.546 160L155.444 146.065L131.797 146.109L124.535 123.607L105.378 109.745L112.728 87.2727L105.378 64.8L124.535 50.9381L131.797 28.4363L155.444 28.48L174.546 14.5454Z",
    stroke: "#29256E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.091 87.2726L167.273 105.454L203.637 69.0908",
    stroke: "#EF406A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.183 161.136L249.183 158.274L244.772 158.274L244.772 153.863H241.91L241.91 158.274L237.5 158.274L237.5 161.136L241.91 161.136V165.546H244.772V161.136L249.183 161.136Z",
    fill: "#79DAE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1145 124.982C45.1145 127.733 42.8842 129.964 40.1327 129.964C37.3812 129.964 35.1509 127.733 35.1509 124.982C35.1509 122.23 37.3812 120 40.1327 120C42.8842 120 45.1145 122.23 45.1145 124.982Z",
    fill: "#29256E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5753 136.573L88.5918 136.818L87.1205 129.676L77.5753 136.573Z",
    stroke: "#EF406A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.09091,
    cy: 27.2725,
    r: 8.59091,
    stroke: "#EF406A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.0307,
    cy: 44.2426,
    r: 5.45455,
    fill: "#98258D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06055 87.2726L12.0215 75.1514L17.9824 87.2726L23.9433 75.1514L29.9042 87.2726L35.8572 75.1514L41.8181 87.2726L47.779 75.1514L53.74 87.2726L59.693 75.1514L65.6539 87.2726L71.6148 75.1514L77.5757 87.2726",
    stroke: "#79DAE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320 38.7881L298.182 47.879L307.273 60.6063L320 38.7881Z",
    stroke: "#EF406A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M309.586 121.212L315.151 125.399L309.586 129.587V121.212Z",
    stroke: "#98258D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.674 121.212L306.238 125.399L300.674 129.587V121.212Z",
    stroke: "#7B7A8C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M291.76 121.212L297.325 125.399L291.76 129.587V121.212Z",
    stroke: "#29256E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M282.847 121.212L288.411 125.399L282.847 129.587V121.212Z",
    stroke: "#EF406A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M273.939 121.212L279.498 125.399L273.939 129.587V121.212Z",
    stroke: "#79DAE8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankingVector);
export default __webpack_public_path__ + "static/media/thanking-vector.79faf6d76d7c53d07b3b434cdaed6777.svg";
export { ForwardRef as ReactComponent };